/* eslint-disable react-hooks/exhaustive-deps */
import AcknowledgementPopup from "Components/common/AcknowledgementPopup";
import AddSingleContactPopup from "Components/common/AddSingleContactPopup";
import NotificationBanner from "Components/common/Banner/NotificationBanner";
import AddBulkContactPopup from "Components/common/bulkContactPopup/AddBulkContactPopup";
import ComingSoonPopup from "Components/common/ComingSoonPopup";
import ConfirmationPopup from "Components/common/confirmationPopup";
import BulkAddTagsPopup from "Components/common/ContactFilter/BulkOperations/BulkAddTagsPopup";
import BulkRemoveTagsPopup from "Components/common/ContactFilter/BulkOperations/BulkRemoveTagsPopup";
import CreditUsagePopup from "Components/common/CreditsUsagePopup";
import DeselectCheckedPopup from "Components/common/DeselectCheckedPopup";
import FindContactPopup from "Components/common/discoverPopup/FindContactPopup";
import FoundContactPopup from "Components/common/discoverPopup/FoundContactPopup";
import NoPhoneCredits from "Components/common/discoverPopup/NoPhoneCredits";
import PhoneNotFound from "Components/common/discoverPopup/PhoneNotFound";
import EditSequencePopup from "Components/common/EditSequencePopup";
import ExportToSalesforcePopup from "Components/common/ExportToSalesforcePopup";
import ExportToZohoPopup from "Components/common/ExportToZohoPopup";
import HeaderNotification from "Components/common/HeaderNotification";
import ImportFromContactsListPopup from "Components/common/ImportFromContactsListPopup";
import InputBoxPopup from "Components/common/inputPopup";
import SuccessPopup from "Components/common/SuccessPopup";
import TagPopup from "Components/common/tags/TagPopup";
import Toaster from "Components/common/toaster";
import TransactionAnimation from "Components/common/TransactionAnimation";
import UpdateContactOwner from "Components/common/UpdateContactOwner";
import CalendarBookMeetingPopup from "Components/ContactCard/CalendarBookMeeting/Main";
import ContactUploadingToSequence from "Components/ContactCard/ContactUploadingToSequence";
import MissingFieldsValidationPopup from "Components/ContactCard/MissingFieldsValidationPopup";
import DialerSliderCard from "Components/DailerService/DialerSliderCard";
import FileLimitExceedPopup from "Components/FileAttachment/FileLimitExceedPopup";
import ContactsSchedulePopup from "Components/popup/ContactsSchedulePopup";
import EnrichProcessing from "Components/popup/EnrichProcessing";
import ExportEmailNotify from "Components/popup/ExportEmailNotify";
import ExportProcessing from "Components/popup/ExportProcessing";
import PriceRangeSliderPopup from "Components/popup/PriceRangeSliderPopup/main";
import EmailPreviewContentPopup from "Components/PreviewPopup/EmailPreviewContentPopup";
import LinkedInReplyContentPopup from "Components/PreviewPopup/LinkedInReplyContentPopup";
import Header from "Global/Header/main";
import SideBar from "Global/SideBar/main";
import { observer } from "mobx-react";
import CreateEditListPopup from "Pages/Dashboard/dataSearch/CustomList/createEditListPopup";
import customListState from "Pages/Dashboard/dataSearch/CustomList/state";
import ApprovalPopup from "Pages/Dashboard/sequences/DeepResearchApproval/ApprovalPopup";
import AddStagesPopup from "Pages/Dashboard/sequences/Stages/AddStagesPopup";
import DeepResearchStepPopup from "Pages/Dashboard/sequences/Stages/DeepResearchStepPopup";
import StepEmailCreateEditorPopup from "Pages/Dashboard/sequences/Stages/StepEmailCreateEditorPopup";
import TestEmailPopup from "Pages/Dashboard/sequences/Stages/TestEmailPopup";
import CreateCallStagePopup from "Pages/Dashboard/settings/Calls/Disposition/CreateCallStagePopup";
import CreateContactStagePopup from "Pages/Dashboard/settings/ContactStages/CreateContactStagePopup";
import { salesforceConnectedData } from "Pages/Dashboard/settings/Crm/salesforce/SalesforceConnectedData";
import ContactAdminMessagePopup from "Pages/Dashboard/settings/MessagePopup";
import CreateTeamPopup from "Pages/Dashboard/settings/UsersAndTeams/Teams/CreateTeamPopup";
import AddMembersPopup from "Pages/Dashboard/settings/UsersAndTeams/Teams/TeamMember/AddMembersPopup";
import SnoozeTaskPopup from "Pages/Dashboard/tasks/PerformTask/snoozeTaskPopup";
import DealifyPopup from "Pages/Register/Dealify/DealifyPopup";
import { default as React, useEffect, useState } from "react";
import { useHistory, useLocation, withRouter } from "react-router-dom";
import DashboardRouting from "Routes/DashboardRouting";
import ConstantObj from "Static/constant";
import { DialerServiceData } from "Stores/DialerServiceStore";
import globalCallState from "Stores/GlobalCallState";
import onboardingStoreData from "Stores/onBoardingData";
import PricingStore from "Stores/Pricing";
import { sequenceStoreData } from "Stores/sequenceData";
import { settingsStoreData } from "Stores/settingsData";
import { tagsStoreData } from "Stores/TagsData";
import userDetail from "Stores/userDetail";
import { writingAssistantStoreData } from "Stores/WritingAssistantData";
import {
  fetchConnectedEmails,
  fetchLinkedInAccounts,
  getStripeInformation
} from "Utils/commonAPI";
import MessageBridge, { MessageTypes } from "Utils/MessageBridge";
import Utils from "Utils/utils";
import PullContacts from "../ImportContactsFromLinkedIn/PullContacts";
import { EmailVerificationLoggedIn } from "../Register/EmailVerificationLoggedIn";
import trackingStore from "../Tracking/trackingStore";
import AddSequenceInContactPopup from "./contacts/addSeqInContactPopup";
import EditContactPopup from "./contacts/EditContactPopup";
import PopupLoader from "./dataSearch/PopupLoader";
import { dataSearchState } from "./dataSearch/state";
import OutboxCardPopup from "./outbox/OutboxCardPopup";
import { outboxStoreData } from "./outbox/outboxStore";
import LinkedInSequenceTemplatePopup from "./sequences/LinkedInSequenceTemplatePopup";
import LinkedInTemplatesListPopup from "./sequences/LinkedInTemplatesListPopup";
import ImportProgressPopup from "./sequences/ProgressJobs/ImportProgressPopup";
import InitialScheduleInfoPopup from "./sequences/SequencePage/InitialScheduleInfoPopup";
import AddMyOwnNumberPopup from "./settings/AddMyOwnNumberPopup";
import AddNumberPopup from "./settings/AddNumberPopup";
import BuyCreditsPopup from "./settings/BuyCreditsPopup";
import BuyNewNumberPopup from "./settings/BuyNewNumberPopup";
import ConnectLinkedInLoading from "./settings/ConnectedAccounts/LinkedInAccounts/popup/ConnectLinkedInLoading";
import LinkedInDetailsPopup from "./settings/ConnectedAccounts/LinkedInAccounts/popup/LinkedInDetailsPopup";
import LinkedInNotConnectedPopup from "./settings/ConnectedAccounts/LinkedInAccounts/popup/LinkedInNotConnectedPopup";
import AddDefaultInbox from "./settings/ConnectInbox/AddDefaultInbox";
import GmailMessagePopup from "./settings/ConnectInbox/GmailMessagePopup";
import GoogleOAuthPopup from "./settings/ConnectInbox/googleOAuthPopup";
import ReconnectSequenceLoadingPopup from "./settings/ConnectInbox/ReconnectSequenceLoadingPopup";
import ReconnectSequencePopup from "./settings/ConnectInbox/ReconnectSequencePopup";
import connectedInboxStore from "./settings/ConnectInbox/store";
import SyncConfirmationPopup from "./settings/Crm/SyncConfirmationPopup";
import SyncLogsHistoryPopup from "./settings/Crm/syncLogsHistoryPopup/main";
import CustomUrlSuccessPopup from "./settings/CustomUrl/CustomUrlSuccessPopup";
import DeleteCustomURLPopup from "./settings/CustomUrl/DeleteCustomUrlPopup";
import NewCardPaymentPopup from "./settings/NewCardPayment";
import CreateSlackNotification from "./settings/Triggers/AddEditTrigger/CreateSlackNotification";
import VerifyNumberPopup from "./settings/VerifyNumberPopup";
import VoBizBuyNumberPopup from "./settings/VoBizBuyNumberPopup";

const DashboardModule = (props = {}) => {
  let location = useLocation();
  let history = useHistory();
  if (location?.hash === "#my_custom_link") {
    // window && window.Intercom("show");
  }
  let queryParams = Utils.getQueryParams(location.search);

  //send count set to -1 during initialization these two will get compared
  const {
    emailSendLimit = 0,
    emailSentCount = -1,
    noOfSequencesUsed = 0
  } = userDetail?.userFeatureFlag || {};

  const [showSideBar, setSideBar] = useState(true);
  const [isTeamSuspended, setTeamSuspendedStatus] = useState(false);
  const [showUpgradePopup, setShowUpgradePopup] = useState(false);
  const [showUpgradeSettingsPopup, setShowUpgradeSettingsPopup] =
    useState(false);
  const [showPluginBanner, setPluginBanner] = useState(false);
  const [showTrackingDelayBanner, setShowTrackingDelayBanner] = useState(false);
  const [revokeAccessBanner, setRevokeAccessBanner] = useState(false);
  const [isLowDialerCredits, setLowDialerCredits] = useState(false);
  const [showDialerServiceCard, setDialerServiceCard] = useState(false);
  const [customUrlBanner, setCustomUrlBanner] = useState(false);
  const [showBanner, setShowBanner] = useState(true);
  const [foundData, setFoundData] = useState(false);
  const [singlePurchaseContactMail, setSinglePurchaseContactMail] =
    useState("");
  const [mobilePhone, setMobilePhone] = useState("");
  const [isMobileNumberFound, setIsMobileNumberFound] = useState(true);
  const [isNoPhoneCredits, setIsNoPhoneCredits] = useState(false);

  let pluginUser = queryParams?.get("source")?.includes("plugin");
  pluginUser && localStorage.setItem("isPluginUser", true);

  const findTeamStatus = teamStatus => {
    switch (teamStatus?.toLowerCase()) {
      case "suspended":
        setTeamSuspendedStatus(true);
        break;
      default:
        setTeamSuspendedStatus(false);
        break;
    }
  };

  const checkPluginInstalled = () => {
    setTimeout(() => {
      const isPluginInstalled = userDetail.pluginInstalled;
      if (!isTeamSuspended && !isPluginInstalled) {
        setPluginBanner(true);
      } else {
        setPluginBanner(false);
      }
    }, 6000);
  };

  const hidePluginBanner = (value = false) => {
    setPluginBanner(value);
  };

  const checkLowDialerCredits = () => {
    const {
      dialerCredits,
      usFreeCallingMinutesEligible = 0,
      usFreeCallingMinutesUsed = 0
    } = userDetail?.userFeatureFlag;
    const purchasedNumbers = DialerServiceData.purchasedNumbers;
    const purchasedNumberCount = purchasedNumbers?.length;
    const freeCallingMinutes =
      usFreeCallingMinutesEligible - usFreeCallingMinutesUsed;
    if (freeCallingMinutes <= 0 && dialerCredits < purchasedNumberCount) {
      setLowDialerCredits(true);
    }
  };

  const getBlockedDomainList = async () => {
    const response = (await Utils.fetchBlockedDomains()) || {};
    if (response) {
      userDetail.setBlockedDomainList(response?.data || []);
    }
  };

  const verifyCustomUrlIsSet = () => {
    const { domain = "" } = userDetail?.brandUrlInfo || {};
    if (!domain) {
      setCustomUrlBanner(true);
    }
  };

  const makeReplyCountApi = async () => {
    const isEmailConnected = await onboardingStoreData.getOnBoardingData();
    if (noOfSequencesUsed > 0 || isEmailConnected) {
      setInterval(() => {
        outboxStoreData.getOutboxUnreadCount();
      }, 900000);
    }
  };

  useEffect(() => {
    checkLowDialerCredits();
  }, [DialerServiceData.purchasedNumbers]);

  useEffect(() => {
    fetchLinkedInAccounts();
    connectedInboxStore.getOAuthConfigs();
    makeReplyCountApi();
    trackingStore.getInstalledScriptDetails();
    Utils.registerMixpanel();
    // Hand the same user context to the Shell (parent of this iframe) once, so
    // the AI Assistant panel's Mixpanel events get userEmail/planType/signupDate
    // and an identified distinct_id just like the in-app events.
    const { email = "" } = userDetail?.userInfo || {};
    const {
      createTs = "",
      planName = "",
      inFreePlan = false
    } = userDetail?.userFeatureFlag || {};
    MessageBridge.sendToShell(MessageTypes.SYNC_USER, {
      email,
      createTs,
      planName,
      inFreePlan
    });
    outboxStoreData.getOutboxUnreadCount();
    settingsStoreData.getSettingsData();
    settingsStoreData.getUnsubscribeData();
    sequenceStoreData.getAllSequenceFolders();
    salesforceConnectedData.getSalesForceOauthData();
    writingAssistantStoreData.getPrompts();
    tagsStoreData.getAllTags();
    customListState.getContactList();
    settingsStoreData.getCustomFields();
    PricingStore.getActivePlanDetails();
    PricingStore.getDataOutreachPlans();
    getStripeInformation();
    fetchConnectedEmails();
    getBlockedDomainList();
    verifyCustomUrlIsSet();

    return () => {
      setShowBanner(true);
    };
  }, []);

  useEffect(() => {
    if (window && window.sg) {
      var sg = window.sg;
      sg.identify(userDetail?.userInfo?.email);
    }
  }, [userDetail?.userInfo]);

  useEffect(() => {
    setShowUpgradePopup(userDetail.showUpgradePopup);
  }, [userDetail.showUpgradePopup]);

  useEffect(() => {
    setShowUpgradeSettingsPopup(userDetail.showUpgradeSettingsPopup);
  }, [userDetail.showUpgradeSettingsPopup]);

  useEffect(() => {
    findTeamStatus(userDetail.userFeatureFlag.teamStatus);
  }, [userDetail.userFeatureFlag.teamStatus]);

  useEffect(() => {
    setSideBar(
      !["/pluginSuccess", "/signupSuccess"].includes(location.pathname)
    );
    globalCallState.setPopupValues({
      ...globalCallState.popupValues,
      isContactCard: false
    });
  }, [location]);

  useEffect(() => {
    checkPluginInstalled();
  }, [userDetail.pluginInstalled]);

  useEffect(() => {
    setRevokeAccessBanner(userDetail?.connectInboxAccessRevoke);
  }, [userDetail.connectInboxAccessRevoke]);

  useEffect(() => {
    setDialerServiceCard(globalCallState.showCallSlider);
  }, [globalCallState.showCallSlider]);

  useEffect(() => {
    verifyCustomUrlIsSet();
  }, [userDetail.brandUrlInfo]);

  useEffect(() => {
    setFoundData(dataSearchState?.foundData);
  }, [dataSearchState?.foundData]);

  useEffect(() => {
    setSinglePurchaseContactMail(dataSearchState?.singlePurchaseContactMail);
  }, [dataSearchState?.singlePurchaseContactMail]);

  useEffect(() => {
    setMobilePhone(dataSearchState?.mobilePhone);
  }, [dataSearchState?.mobilePhone]);

  useEffect(() => {
    setIsMobileNumberFound(dataSearchState?.isMobileNumberNotFound);
  }, [dataSearchState?.isMobileNumberNotFound]);

  useEffect(() => {
    setIsNoPhoneCredits(dataSearchState?.isNoPhoneCredits);
  }, [dataSearchState?.isNoPhoneCredits]);

  return (
    <>
      {!showSideBar && <DashboardRouting />}
      <DealifyPopup />
      <Header />
      {showSideBar && (
        <>
          <aside>
            <SideBar />
          </aside>
          {showDialerServiceCard && (
            <DialerSliderCard
              data={globalCallState.popupValues.contactData}
              slideAnimation={true}
              setDialerServiceCard={setDialerServiceCard}
              dialerLogAfterCallEnd={
                globalCallState.popupValues.dialerLogAfterCallEnd
              }
              performTaskCbk={globalCallState.popupValues.performCbkFunction}
              isFromContactSection={
                globalCallState.popupValues.isFromContactSection
              }
              pageType={globalCallState.popupValues.pageType}
              isContactCard={globalCallState.popupValues.isContactCard}
              selectedNumber={globalCallState.popupValues.selectedNumber}
            />
          )}
          {DialerServiceData.dialerCallStatus === "connected" && (
            <div className="aiNotesFooter">
              <div className="aiNotesFooterLeft">
                <span className="aiNotesCallerDot" />
                <span className="aiNotesCallerName">
                  {(name => name === "--" ? null : name)(Utils.getName(
                    globalCallState.popupValues.contactData?.firstName,
                    globalCallState.popupValues.contactData?.lastName,
                    globalCallState.popupValues.contactData?.name
                  )) || globalCallState.popupValues.selectedNumber || DialerServiceData.activePhoneNo || "Unknown"}
                </span>
                <span className="aiNotesTimer">
                  {String(Math.floor(DialerServiceData.callDurationSeconds / 60)).padStart(2, "0")}:
                  {String(DialerServiceData.callDurationSeconds % 60).padStart(2, "0")}
                </span>
              </div>
              <div className="aiNotesCenter">
                <div className="aiNotesWave">
                  {[...Array(7)].map((_, i) => (
                    <span key={i} className="aiNotesWaveBar" />
                  ))}
                </div>
                <span className="aiNotesText">AI is taking notes</span>
              </div>
              <div className="aiNotesFooterRight">
                <button
                  className="aiNotesEndCallBtn"
                  onClick={() => DialerServiceData.setEndCallRequested(true)}
                >
                  <i className="material-icons">call_end</i>
                  End call
                </button>
              </div>
            </div>
          )}
          <ConfirmationPopup />
          <AcknowledgementPopup />
          {/* {!isWelcomeVideoShown && <WelcomePopup cbk={welcomeVideoShown} />} */}
          <InputBoxPopup />
          <Toaster />
          <SnoozeTaskPopup />
          <AddSequenceInContactPopup {...props} />
          <EditContactPopup />
          <ExportProcessing />
          <EnrichProcessing />
          <ExportEmailNotify />
          <BuyNewNumberPopup />
          <VoBizBuyNumberPopup />
          <BuyCreditsPopup />
          <TransactionAnimation />
          <AddNumberPopup />
          <AddMyOwnNumberPopup />
          <VerifyNumberPopup />
          <NewCardPaymentPopup />
          <DeleteCustomURLPopup />
          <CustomUrlSuccessPopup />
          <FileLimitExceedPopup />
          <EditSequencePopup />
          <EmailVerificationLoggedIn />
          <ComingSoonPopup />
          {/* <BookNowBanner /> */}
          <TagPopup />
          <AddBulkContactPopup />
          <SuccessPopup />
          <DeselectCheckedPopup />
          <AddSingleContactPopup />
          <OutboxCardPopup />
          <GmailMessagePopup />
          {/* <UpgradePopup /> */}
          <StepEmailCreateEditorPopup />
          <TestEmailPopup />
          <AddStagesPopup />
          <DeepResearchStepPopup />
          <ApprovalPopup />
          <ContactsSchedulePopup {...props} />
          <BulkAddTagsPopup />
          <BulkRemoveTagsPopup />
          <ContactUploadingToSequence />
          <MissingFieldsValidationPopup />
          {/* {showUpgradePopup && <UpgradeCard />} */}
          {/* {showUpgradeSettingsPopup && <UpgradeSettingsCard />}
          <InitialWelcomePopup /> */}
          <CreateEditListPopup />
          <CreateTeamPopup />
          <CreateContactStagePopup />
          <CreateCallStagePopup />
          <AddMembersPopup />
          <AddDefaultInbox />
          <ReconnectSequencePopup />
          <ReconnectSequenceLoadingPopup />
          <InitialScheduleInfoPopup />
          <ContactAdminMessagePopup />
          <PopupLoader />
          <EmailPreviewContentPopup />
          <LinkedInReplyContentPopup />
          {/* <AddLinkedInAccountPopup /> */}
          <CalendarBookMeetingPopup />
          <UpdateContactOwner />
          <ExportToSalesforcePopup />
          <ExportToZohoPopup />
          <GoogleOAuthPopup />
          <CreateSlackNotification />
          <LinkedInNotConnectedPopup />
          <ConnectLinkedInLoading />
          <LinkedInDetailsPopup />
          <SyncConfirmationPopup />
          <SyncLogsHistoryPopup />
          <PriceRangeSliderPopup />
          <CreditUsagePopup />
          <PullContacts />
          <ImportFromContactsListPopup />
          <ImportProgressPopup />
          <LinkedInSequenceTemplatePopup />
          <LinkedInTemplatesListPopup />


          <div className="seqBulkPopupWrapper" id="seqBulkPopupWrapper">
            <div className="seqBulkCont" />
            <div className="common-popup-mask bulkMask" />
          </div>
          <section
            className={`site-content ${isTeamSuspended && !(emailSentCount >= emailSendLimit)
              ? "singleBanner"
              : "installBannerHidden"
              }`}
          >
            {showBanner && (
              <WarningBanner
                isTeamSuspended={isTeamSuspended}
                revokeAccessBanner={revokeAccessBanner}
                isLowDialerCredits={isLowDialerCredits}
                showPluginBanner={showPluginBanner}
                emailSendLimit={emailSendLimit}
                showTrackingDelayBanner={showTrackingDelayBanner}
                emailLimitBanner={emailSentCount >= emailSendLimit}
                customUrlBanner={customUrlBanner}
                dhcBanner={
                  localStorage.getItem("domainHealthCenterVisited") === null
                }
                setShowBanner={setShowBanner}
              />
            )}
            <main className="mainPage">
              {/* <OnBoardingPopup /> */}
              <DashboardRouting />
              {dataSearchState?.isFindPhoneEmailClicked && <FindContactPopup />}
              {foundData &&
                (singlePurchaseContactMail ||
                  (mobilePhone && isMobileNumberFound)) && (
                  <FoundContactPopup key={dataSearchState?.mobilePhone} />
                )}

              {!isMobileNumberFound && <PhoneNotFound />}
              {isNoPhoneCredits && <NoPhoneCredits />}
            </main>
          </section>
        </>
      )}
    </>
  );
};

const WarningBanner = (props = {}) => {
  const {
    isTeamSuspended = false,
    revokeAccessBanner = false,
    isLowDialerCredits = false,
    showTrackingDelayBanner = false,
    emailLimitBanner = false,
    showPluginBanner = false,
    emailSendLimit = 0,
    customUrlBanner = false,
    dhcBanner = localStorage.getItem("domainHealthCenterVisited") === null,
    setShowBanner = () => { }
  } = props || {};
  const getBannerType = () => {
    if (emailLimitBanner) {
      return "EMAIL_LIMIT";
    } else if (isTeamSuspended && !emailLimitBanner) {
      return "TEAM_SUSPENDED";
    } else if (isLowDialerCredits && !emailLimitBanner && !isTeamSuspended) {
      return "DAILER_CREDITS";
    } else if (
      revokeAccessBanner &&
      !emailLimitBanner &&
      !isTeamSuspended &&
      !isLowDialerCredits
    ) {
      return "CONNECT_INBOX";
    } else if (
      showTrackingDelayBanner &&
      !revokeAccessBanner &&
      !emailLimitBanner &&
      !isTeamSuspended &&
      !isLowDialerCredits
    ) {
      return "TRACKING_DELAY";
    } else if (
      customUrlBanner &&
      !showTrackingDelayBanner &&
      !revokeAccessBanner &&
      !emailLimitBanner &&
      !isTeamSuspended &&
      !isLowDialerCredits
    ) {
      return "CUSTOM_URL";
    } else if (
      dhcBanner &&
      !customUrlBanner &&
      !showTrackingDelayBanner &&
      !revokeAccessBanner &&
      !emailLimitBanner &&
      !isTeamSuspended &&
      !isLowDialerCredits
    ) {
      return "DHC";
    } else if (
      showPluginBanner &&
      !dhcBanner &&
      !customUrlBanner &&
      !showTrackingDelayBanner &&
      !revokeAccessBanner &&
      !emailLimitBanner &&
      !isTeamSuspended &&
      !isLowDialerCredits
    ) {
      return "EXTENSION";
    }
  };

  let bannerType = getBannerType();

  return isTeamSuspended &&
    !emailLimitBanner &&
    ["TEAM_SUSPENDED"].includes(bannerType?.toUpperCase()) ? (
    <HeaderNotification message={ConstantObj.teamSuspendedMessage} />
  ) : (
    [
      "EMAIL_LIMIT",
      "DAILER_CREDITS",
      "CONNECT_INBOX",
      "CUSTOM_URL",
      "DHC",
      "EXTENSION"
    ].includes(bannerType) && (
      <NotificationBanner
        emailSendLimit={emailSendLimit}
        hideBanner={setShowBanner}
        bannerType={bannerType}
      />
    )
  );
};

export default withRouter(observer(DashboardModule));
